exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-shared-Modal-modal .src-components-shared-Modal-body{height:250px}.src-components-shared-Modal-close{position:absolute;right:20px;border:none;background:none;font-weight:bolder}", ""]);

// exports
exports.locals = {
	"modal": "src-components-shared-Modal-modal",
	"body": "src-components-shared-Modal-body",
	"close": "src-components-shared-Modal-close"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/Modal/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/Modal/styles.scss
// module chunks = 1